// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import $ from 'jquery';

// Styles
import './_menu.scss';
import './_menu--dropdown.scss';

// -------------------------------------
// Hooks
// -------------------------------------

function openMenu(menu, focusItem) {
    closeAllMenus(menu.$dropdown);
    menu.$dropdown.addClass('js--isOpen');
    menu.$dropdown.children('.menu__link').attr('aria-expanded', 'true');

    if (!menu.$dropdown.hasClass('menu__item--footer')) {
        $('body').addClass('menu--isOpen');
    }

    $('.header').addClass('header--background')
    menu.$dropdown.find('a').removeAttr('tabindex')

    focusItem.focus();
}

function closeMenu(submenu) {
    // close menu
    submenu.$parentDropdown.removeClass('js--isOpen');
    submenu.$parentDropdown.children('.menu__link').attr('aria-expanded', 'false');

    if (!submenu.$parentDropdown.hasClass('menu__item--footer')) {
        $('body').removeClass('menu--isOpen');
    }

    $('.header').removeClass('header--background')
    submenu.$parentDropdown.find('.dropdown__link, .card--promo-wrapper, .card-link').attr('tabindex', '-1');
}

function closeAllMenus(menuDropdown) {
    menuDropdown.removeClass('js--isOpen');
    menuDropdown.siblings().removeClass('js--isOpen');
    menuDropdown.children('.menu__link').attr('aria-expanded', 'false');
    menuDropdown.siblings().children('.menu__link').attr('aria-expanded', 'false');
    
    $('.header').removeClass('header--background')
    menuDropdown.find('.dropdown__link, .card--promo-wrapper, .card-link').attr('tabindex', '-1');
    menuDropdown.siblings().find('.dropdown__link, .card--promo-wrapper, .card-link').attr('tabindex', '-1');
}

function moveFocusTo(focusItem) {
    focusItem.focus();
}

function moveTabindex(menuDropdown, menuLink) {
    menuDropdown.parents('.menu__list').find('.menu__link').attr('tabindex', '-1');
    menuLink.attr('tabindex', '0');
}

function handleHoverMenu(e) {
    e.preventDefault();

    const $menuItem = $(e.currentTarget);
    const $header = $menuItem.closest('.header--home');

    if (e.type === 'mouseenter') {
        // Remove delay by directly adding class
        $('.menu__item--dropdown:not(.menu__item--dropdown--secondary)').removeClass('js--isOpen');
        $menuItem.addClass('js--isOpen');
        $header.addClass('header--background');

        // if (!$menuItem.hasClass('menu__item--footer')) {
        //     $header.addClass('header--background');
        //     $('body').addClass('menu--isOpen');
        // }
    } else if (e.type === 'mouseleave') {
        if (!$header.find(e.toElement).closest('.menu__item').length) {
            let st = document.documentElement.scrollTop;

            // Remove delay by directly removing class
            $menuItem.removeClass('js--isOpen');
            
            if (st < 80) {
                $header.removeClass('header--background');
            }

            if (!$menuItem.hasClass('menu__item--footer')) {
                $('body').removeClass('menu--isOpen');
            }
        }
    }
}

function hoverMenu() {
    const $menuItems = $('.menu__item');
    const $dropdowns = $('.menu__item--dropdown:not(.menu__item--dropdown--secondary)');

    if (window.innerWidth >= 1024) {
        $dropdowns.addClass('js--bound');
        $menuItems.on('mouseenter', handleHoverMenu);
        $menuItems.on('mouseleave', handleHoverMenu);
    } else {
        $dropdowns.removeClass('js--bound');
        $menuItems.off('mouseenter mouseleave', handleHoverMenu);
    }
}

function fixMenu() {
    if (window.innerWidth > 1024) {
        $(document).on('click', '.menu__item--dropdown .menu__link', function(e) {
            e.preventDefault();

            const $dropdown = $(this).closest('.menu__item--dropdown');
            $dropdown.toggleClass('js--isFixed');

            if ($dropdown.hasClass('js--isFixed')) {
                $('body').addClass('menu--isFixed');
            } else {
                $('body').removeClass('menu--isFixed');
            }

            $('.menu__item--dropdown').not($dropdown).removeClass('js--isFixed');
        });

        $(document).on('click', function(e) {
            if (!$(e.target).closest('.menu__item--dropdown').length) {
                $('.menu__item--dropdown').removeClass('js--isFixed');
                $('body').removeClass('menu--isFixed');
            }
        });
    }
}

$(function() {
    $(document).on('click', function() {
        $('body').removeClass('menu--isOpen');
    });

    $(document).on('click', '.menu__item--dropdown .menu__link, .dropdown__mobile-back', function(e) {
        e.stopPropagation();

        const $dropdown = $(this).closest('.menu__item--dropdown');

        if ($dropdown.hasClass('js--isOpen')) {
            if (!$dropdown.hasClass('menu__item--footer')) {
                $('body').removeClass('menu--isOpen');
            }
        } else {
            if (!$dropdown.hasClass('menu__item--footer')) {
                $('body').addClass('menu--isOpen');
            }
        }

        if ($dropdown.siblings().hasClass('js--isOpen')) {
            $dropdown.siblings().removeClass('js--isOpen');
            $dropdown.addClass('js--isOpen');
        } else {
            $dropdown.toggleClass('js--isOpen');
        }
    });

    hoverMenu();
    fixMenu();
    $(window).on('resize', hoverMenu);

    $(document).on('keydown', '.menu--header .menu__item .menu__link', function(e) {
        const menu = {
            $menuLink: $(e.target),
            $menuItem: $(e.target).closest('.menu__item'),
            $dropdownList: $(e.target).closest('.dropdown__list'),
            $dropdown: $(e.target).closest('.menu__item--dropdown'),
            $dropdownLink: $(e.target).closest('.dropdown__link'),
        };

        const key = e.key;
        if (key === 'Tab') {
            return;
        } else {
            e.preventDefault();

            let menuItem, menuItemLink, focusLink;

            switch (key) {
                case 'Enter':
                case ' ':
                    focusLink = menu.$dropdown.find('.dropdown__link').first();
                    openMenu(menu, focusLink);
                    break;
                case 'ArrowLeft':
                    menuItem = menu.$menuLink.parent().prev();
                    if (!menuItem.length) menuItem = menu.$menuLink.parent().siblings().last();
                    menuItemLink = menuItem.children('.menu__link');
                    moveFocusTo(menuItemLink);
                    moveTabindex(menu.$menuItem, menuItemLink);
                    break;
                case 'ArrowRight':
                    menuItem = menu.$menuLink.parent().next();
                    if (!menuItem.length) menuItem = menu.$menuLink.parent().siblings().first();
                    menuItemLink = menuItem.children('.menu__link');
                    moveFocusTo(menuItemLink);
                    moveTabindex(menu.$menuItem, menuItemLink);
                    break;
                case 'ArrowUp':
                    focusLink = menu.$dropdown.find('.dropdown__link').last();
                    openMenu(menu, focusLink);
                    break;
                case 'ArrowDown':
                    focusLink = menu.$dropdown.find('.dropdown__link').first();
                    openMenu(menu, focusLink);
                    break;
                case 'Home':
                    menuItem = menu.$menuLink.parent().siblings().first();
                    menuItemLink = menuItem.children('.menu__link');
                    moveFocusTo(menuItemLink);
                    moveTabindex(menu.$menuItem, menuItemLink);
                    break;
                case 'End':
                    menuItem = menu.$menuLink.parent().siblings().last();
                    menuItemLink = menuItem.children('.menu__link');
                    moveFocusTo(menuItemLink);
                    moveTabindex(menu.$menuItem, menuItemLink);
                    break;
                default:
                    menu.$menuItem.siblings().each(function(index, item) {
                        const menuLink = $(item).children('.menu__link');
                        const firstChar = menuLink[0].innerText.charAt(0).toLowerCase();
                        if (key.toLowerCase() === firstChar) {
                            moveFocusTo(menuLink);
                            moveTabindex($(item), menuLink);
                            return false;
                        }
                    });
            }
        }
    });

    $(document).on('keydown', '.dropdown__item .dropdown__link', function(e) {
        const submenu = {
            $menuLink: $(e.target),
            $dropdown: $(e.target).parent(),
            $parentDropdown: $(e.target).parents('.menu__item'),
            $parentLink: $(e.target).parents('.menu__item').children('.menu__link')
        };

        const key = e.key;
        if (key === 'Tab') {
            return;
        } else {
            e.preventDefault();

            let menuItem, menuItemLink;

            switch (key) {
                case 'Enter':
                case ' ':
                    submenu.$menuLink[0].click();
                    break;
                case 'Escape':
                    closeMenu(submenu);
                    moveFocusTo(submenu.$parentLink);
                    break;
                case 'ArrowLeft':
                    menuItem = submenu.$parentDropdown.prev();
                    if (!menuItem.length) menuItem = submenu.$parentDropdown.siblings().last();
                    menuItemLink = menuItem.children('.menu__link');
                    closeMenu(submenu);
                    moveFocusTo(menuItemLink);
                    break;
                case 'ArrowRight':
                    menuItem = submenu.$parentDropdown.next();
                    if (!menuItem.length) menuItem = submenu.$parentDropdown.siblings().first();
                    menuItemLink = menuItem.children('.menu__link');
                    closeMenu(submenu);
                    moveFocusTo(menuItemLink);
                    break;
                case 'ArrowUp':
                    menuItem = submenu.$dropdown.prev();
                    if (!menuItem.length) menuItem = submenu.$dropdown.siblings().last();
                    menuItemLink = menuItem.children('.dropdown__link');
                    moveFocusTo(menuItemLink);
                    break;
                case 'ArrowDown':
                    menuItem = submenu.$dropdown.next();
                    if (!menuItem.length) menuItem = submenu.$dropdown.siblings().first();
                    menuItemLink = menuItem.children('.dropdown__link');
                    moveFocusTo(menuItemLink);
                    break;
                case 'Home':
                    menuItem = submenu.$dropdown.siblings().first();
                    menuItemLink = menuItem.children('.dropdown__link');
                    moveFocusTo(menuItemLink);
                    break;
                case 'End':
                    menuItem = submenu.$dropdown.siblings().last();
                    menuItemLink = menuItem.children('.dropdown__link');
                    moveFocusTo(menuItemLink);
                    break;
                default:
                    e.preventDefault();
                    submenu.$dropdown.siblings().each(function(index, item) {
                        const menuLink = $(item).children('.dropdown__link');
                        const firstChar = menuLink[0].innerText.charAt(0).toLowerCase();
                        if (key.toLowerCase() === firstChar) {
                            moveFocusTo(menuLink);
                            moveTabindex($(item), menuLink);
                            return false;
                        }
                    });
            }
        }
    });

    $(document).on('click', '.menu__item--dropdown .menu__link', function(e) {
        e.preventDefault();
    });

    $(document).on('mouseenter', '.mega-nav .dropdown__item--column-first .dropdown__item:not(.dropdown__item--image)', function() {
        const $dropdownLink = $(this).find('.dropdown__link');
        const dropdownLinkImage = $dropdownLink.data('collection');
        const dropdownLinkText = $dropdownLink.data('collection-title');

        if (dropdownLinkImage) {
            $('.collection-image').find('.collection-image__image').attr('src', dropdownLinkImage);
            $('.collection-image').find('.collection-image__title').text(dropdownLinkText);
            $('.collection-image').css({ display: 'grid', 'z-index': '5' });
        } else {
            $('.collection-image').css({ display: 'none', 'z-index': '-1' });
        }
    });

    $(document).on('mouseleave', '.mega-nav .dropdown__item', function() {
        $('.collection-image').css({ display: 'none', 'z-index': '-1' });
    });
});
